export const BOOKING_STEP_DATA_GRABS = {
    selectionListWrapper: 'booking-selection-list-wrapper',
} as const;
